import { render, staticRenderFns } from "./LoadingDescarga.vue?vue&type=template&id=3a656c28&"
import script from "./LoadingDescarga.vue?vue&type=script&lang=js&"
export * from "./LoadingDescarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports